import styled, { css } from 'styled-components';
import { devices } from '../../../../utils/responsive';

export const Content = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    fuel-typography {
      :first-child {
        text-transform: capitalize;
      }
    }

    fuel-tooltip {
      text-transform: none;
    }

    fuel-icon {
      &[name='verified-check'] {
        color: ${theme.color.support.blue.strong};
      }

      &[name='money'] {
        color: ${theme.color.icon.success.default};
      }
    }
  `}
`;

export const WrapperAlignRigth = styled.div`
  margin-left: auto;
`;

export const WrapperNewLineMobile = styled.div`
  ${({ theme }) => css`
    margin-left: ${theme.spacing.km2};

    @media ${devices.mobile} {
      flex: 1 1 100%;
      margin-top: ${theme.spacing.km4};
      justify-content: flex-end;
      display: flex;
    }
  `}
`;

export const RatingWrapper = styled.div<{ $hasRating: boolean }>`
  margin-top: ${({ theme }) => theme.spacing.km1};

  fuel-icon {
    &[name='star'] {
      color: ${({ theme, $hasRating }) =>
        $hasRating
          ? theme.color.support.orange.strong
          : theme.color.icon.neutral.default};
    }
  }
`;

export const TagVipWrapper = styled.div`
  margin-left: ${({ theme }) => theme.spacing.km1};
`;

export const ShieldLockIcon = styled.img`
  ${({ theme }) => css`
    width: ${theme.spacing.km4};
    height: ${theme.spacing.km4};
    color: ${theme.color.support.blue.strong};
  `}
`;
